// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCourses-cls1_ifz","cls2":"NewCourses-cls2_VqU NewCourses-cls1_ifz"};